import React from 'react';
import { Button, Card, Divider, Flex, Form, Input, Space } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

const LoginMobile = ({ viewModel }) => {
  const {
    token,
    form,
    loginError,
    handleContinue,
    onFinish,
    goResetPassword,
    goRegister,
  } = viewModel;

  return (
    <Card style={{ width: '100vw' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" align="center">
          <img alt="sipro-logo" width={200} style={{ borderRadius: '8px' }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>Vận hành bán sỉ thông minh</span>
          <span>Nền tảng hỗ trợ bán sỉ chuyên nghiệp toàn diện</span>
        </Space>
        <Form layout="vertical" form={form} initialValues={{}} onFinish={onFinish}>
          <Form.Item
            label="Tài khoản đăng nhập"
            name="login_id"
            validateTrigger="onBlur"
            rules={[
              {
                required: true,
                message: 'Bạn phải nhập tài khoản đăng nhập',
              },
            ]}
          >
            <Input placeholder="Tài khoản hoặc số điện thoại"></Input>
          </Form.Item>

          <Form.Item
            label="Password"
            name="pass"
            rules={[
              {
                required: true,
                message: 'Password is required',
              },
            ]}
          >
            <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
          </Form.Item>

          <Space direction="vertical" style={{ width: '100%' }} size={'large'}>
            {loginError && (
              <div style={{ float: 'right' }}>
                <span style={{ color: token.colorErrorText }}>{loginError.message}</span>
              </div>
            )}

            <div style={{ float: 'right' }}>
              <Button size="small" type="link" onClick={goResetPassword}>
                Forgot password?
              </Button>
            </div>

            <Button type="primary" style={{ width: '100%' }} onClick={handleContinue}>
              Đăng nhập
            </Button>

            <Divider orientation="center" style={{ opacity: '0.5' }}>
              Hoặc
            </Divider>

            <Button type="primary" style={{ width: '100%' }} onClick={goRegister}>
              Đăng ký
            </Button>
          </Space>
        </Form>
      </Flex>
    </Card>
  );
};

export default LoginMobile;
